import { Fee } from '../types';

const schoolId = '750e8400-e29b-41d4-a716-446655440001';

export const mockFees: Fee[] = [
  {
    id: 'donation-001',
    name: 'School Donation',
    description: 'Support our school with a tax-deductible donation. Every contribution helps enhance educational programs and student experiences.',
    categoryId: '1',
    basePrice: 20.00,
    reducedPrice: 20.00,
    freePrice: 20.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
    allowsCustomAmount: true,
    customAmountPresets: [20, 50, 100],
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440001',
    name: 'Monthly Bus Pass',
    description: 'Unlimited bus transportation for one month',
    categoryId: '2',
    basePrice: 50.00,
    reducedPrice: 25.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2025-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 12,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440002',
    name: 'Semester Bus Pass',
    description: 'Unlimited bus transportation for one semester',
    categoryId: '2',
    basePrice: 225.00,
    reducedPrice: 112.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2025-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 2,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440003',
    name: 'Art Supplies Kit',
    description: 'Complete set of art supplies for the semester',
    categoryId: '3',
    course: 'Art 101',
    basePrice: 35.00,
    reducedPrice: 17.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2025-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 5,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440004',
    name: 'Science Lab Materials',
    description: 'Required materials for chemistry and biology labs',
    categoryId: '3',
    course: 'Chemistry 201',
    basePrice: 45.00,
    reducedPrice: 22.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2025-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 3,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440005',
    name: 'Graphing Calculator',
    description: 'TI-84 Plus CE graphing calculator for mathematics courses',
    categoryId: '3',
    course: 'Algebra II',
    basePrice: 120.00,
    reducedPrice: 60.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2025-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 2,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440006',
    name: 'Science Museum Trip',
    description: 'Field trip to the National Science Museum with lunch included',
    categoryId: '4',
    course: 'Biology 101',
    basePrice: 30.00,
    reducedPrice: 15.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-03-01'),
    availableTo: new Date('2026-03-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    termsAndConditions: {
      title: 'Field Trip Waiver and Release',
      content: `**FIELD TRIP WAIVER AND RELEASE OF LIABILITY**

**Trip Details:**
- Destination: National Science Museum
- Date: March 12, 2024
- Departure: 8:00 AM from school
- Return: Approximately 3:30 PM

**Terms and Conditions:**

1. **Medical Authorization:** I authorize school officials to obtain necessary medical treatment for my child in case of emergency during the field trip.

2. **Transportation:** I understand that students will be transported by school bus and agree to the terms of school transportation policies.

3. **Supervision:** I understand that students will be supervised by school staff and chaperones throughout the trip, but that constant one-on-one supervision cannot be guaranteed.

4. **Behavior Expectations:** I understand my child must follow all school rules and behavior expectations during the trip. Failure to comply may result in early pickup at parent's expense.

5. **Lunch and Dietary Restrictions:** Lunch is included. Any dietary restrictions or allergies must be communicated separately to the school office.

6. **Release of Liability:** I hereby release, waive, discharge, and covenant not to sue the school district, its officers, employees, and agents from any and all liability, claims, demands, or causes of action whatsoever arising out of or related to any loss, damage, or injury that may be sustained by my child during the field trip.

7. **Photo/Video Release:** I grant permission for my child to be photographed or recorded during the field trip for educational purposes.

8. **Emergency Contact:** I understand I must be reachable by phone during the field trip hours and will respond promptly if contacted.

**Acknowledgment:** By signing below, I acknowledge that I have read and understand the above terms and conditions, and I give permission for my child to participate in this field trip.`,
      requiresSignature: true,
      signatureLabel: 'Parent/Guardian Full Name',
    },
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440007',
    name: 'Historical Society Trip',
    description: 'Educational field trip to the State Historical Society',
    categoryId: '4',
    course: 'US History',
    basePrice: 25.00,
    reducedPrice: 12.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-04-01'),
    availableTo: new Date('2026-04-30'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440008',
    name: 'Spring Concert Ticket',
    description: 'General admission ticket to the annual spring concert',
    categoryId: '5',
    basePrice: 10.00,
    reducedPrice: 5.00,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 5.00,
      adult: 10.00,
      senior: 8.00,
    },
    availableFrom: new Date('2025-04-01'),
    availableTo: new Date('2026-05-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440009',
    name: 'Winter Play Ticket',
    description: 'Reserved seating for the winter theatrical performance',
    categoryId: '5',
    basePrice: 15.00,
    reducedPrice: 7.50,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 7.50,
      adult: 15.00,
      senior: 12.00,
    },
    availableFrom: new Date('2024-11-01'),
    availableTo: new Date('2024-12-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 10,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440010',
    name: 'Yearbook',
    description: '2024-2025 school yearbook with personalization',
    categoryId: '6',
    basePrice: 65.00,
    reducedPrice: 32.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-03-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 3,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440011',
    name: 'PE Uniform Set',
    description: 'Required physical education uniform (shirt and shorts)',
    categoryId: '6',
    basePrice: 28.00,
    reducedPrice: 14.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2025-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 5,
    questionnaire: [
      {
        id: 'shirt_size',
        label: 'Shirt Size',
        type: 'select',
        required: true,
        options: [
          { value: 'xs', label: 'Extra Small (XS)' },
          { value: 's', label: 'Small (S)' },
          { value: 'm', label: 'Medium (M)' },
          { value: 'l', label: 'Large (L)' },
          { value: 'xl', label: 'Extra Large (XL)' },
          { value: 'xxl', label: 'XXL' },
        ],
        helperText: 'Select the appropriate shirt size',
      },
      {
        id: 'shorts_size',
        label: 'Shorts Size',
        type: 'select',
        required: true,
        options: [
          { value: 'xs', label: 'Extra Small (XS)' },
          { value: 's', label: 'Small (S)' },
          { value: 'm', label: 'Medium (M)' },
          { value: 'l', label: 'Large (L)' },
          { value: 'xl', label: 'Extra Large (XL)' },
          { value: 'xxl', label: 'XXL' },
        ],
        helperText: 'Select the appropriate shorts size',
      },
    ],
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440012',
    name: 'Parking Permit',
    description: 'Annual student parking permit for school lot',
    categoryId: '6',
    basePrice: 100.00,
    reducedPrice: 50.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-08-01'),
    availableTo: new Date('2025-08-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440013',
    name: 'Summer Reading Program',
    description: 'Summer enrichment reading program materials',
    categoryId: '3',
    basePrice: 40.00,
    reducedPrice: 20.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-05-01'),
    availableTo: new Date('2025-06-30'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440003'],
    requiresQuantity: true,
    maxQuantity: 3,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440014',
    name: 'Summer Sports Camp',
    description: 'Week-long sports and activities camp',
    categoryId: '5',
    basePrice: 150.00,
    reducedPrice: 75.00,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 150.00,
      adult: 0.00,
      senior: 0.00,
    },
    availableFrom: new Date('2025-05-01'),
    availableTo: new Date('2025-07-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440003'],
    requiresQuantity: true,
    maxQuantity: 4,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440015',
    name: 'Laptop Rental',
    description: 'School-issued laptop rental for academic year',
    categoryId: '6',
    basePrice: 200.00,
    reducedPrice: 100.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-07-01'),
    availableTo: new Date('2025-09-30'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440016',
    name: 'Advanced Chemistry Lab Kit',
    description: 'Complete chemistry lab kit with safety goggles and materials',
    categoryId: '3',
    course: 'AP Chemistry',
    basePrice: 85.00,
    reducedPrice: 42.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 2,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440017',
    name: 'Music Theory Materials',
    description: 'Required workbooks and sheet music for music theory class',
    categoryId: '3',
    course: 'Music Theory',
    basePrice: 55.00,
    reducedPrice: 27.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440018',
    name: 'Fall Sports Physical',
    description: 'Required physical examination for fall sports participation',
    categoryId: '6',
    basePrice: 40.00,
    reducedPrice: 20.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2025-09-30'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440019',
    name: 'Student Activity Pass',
    description: 'All-access pass to school activities and sporting events. Provides discounted or free entry to select events throughout the year.',
    categoryId: '5',
    basePrice: 75.00,
    reducedPrice: 37.50,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 75.00,
      adult: 0.00,
      senior: 0.00,
    },
    isActivityPass: true,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440020',
    name: 'Robotics Club Fee',
    description: 'Annual membership fee for robotics club with materials',
    categoryId: '6',
    basePrice: 125.00,
    reducedPrice: 62.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2025-10-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440021',
    name: 'Drama Club Materials',
    description: 'Costumes, props, and script materials for drama club',
    categoryId: '6',
    basePrice: 60.00,
    reducedPrice: 30.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440022',
    name: 'Spanish Workbook Set',
    description: 'Required workbooks and materials for Spanish class',
    categoryId: '3',
    course: 'Spanish I',
    basePrice: 42.00,
    reducedPrice: 21.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-08-01'),
    availableTo: new Date('2025-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440023',
    name: 'French Language Materials',
    description: 'Textbooks and audio materials for French class',
    categoryId: '3',
    course: 'French II',
    basePrice: 48.00,
    reducedPrice: 24.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440024',
    name: 'Engineering Design Tools',
    description: 'Professional tools and materials for engineering design course',
    categoryId: '3',
    course: 'Engineering Design',
    basePrice: 95.00,
    reducedPrice: 47.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440025',
    name: 'Photography Lab Fee',
    description: 'Dark room access and photo paper for photography students',
    categoryId: '3',
    course: 'Photography 101',
    basePrice: 75.00,
    reducedPrice: 37.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440026',
    name: 'Culinary Arts Supplies',
    description: 'Ingredients and supplies for culinary arts class',
    categoryId: '3',
    course: 'Culinary Arts',
    basePrice: 110.00,
    reducedPrice: 55.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440027',
    name: 'Orchestra Rental Fee',
    description: 'Instrument rental and maintenance for orchestra students',
    categoryId: '6',
    basePrice: 180.00,
    reducedPrice: 90.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440028',
    name: 'Band Uniform',
    description: 'Complete marching band uniform with accessories',
    categoryId: '6',
    basePrice: 150.00,
    reducedPrice: 75.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2025-09-30'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440029',
    name: 'Debate Club Registration',
    description: 'Tournament fees and materials for debate club',
    categoryId: '6',
    basePrice: 85.00,
    reducedPrice: 42.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440030',
    name: 'Model UN Conference',
    description: 'Registration and materials for Model United Nations conference',
    categoryId: '4',
    basePrice: 95.00,
    reducedPrice: 47.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-01-01'),
    availableTo: new Date('2025-02-28'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440031',
    name: 'Senior Prom Ticket',
    description: 'Admission ticket to senior prom event',
    categoryId: '5',
    basePrice: 45.00,
    reducedPrice: 22.50,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 45.00,
      adult: 0.00,
      senior: 0.00,
    },
    activityPassPricing: {
      enabled: true,
      price: 35.00,
      isFree: false,
      quantity: 1,
    },
    availableFrom: new Date('2025-03-01'),
    availableTo: new Date('2025-05-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 2,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440032',
    name: 'Homecoming Dance Ticket',
    description: 'Entry to annual homecoming dance',
    categoryId: '5',
    basePrice: 20.00,
    reducedPrice: 10.00,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 20.00,
      adult: 0.00,
      senior: 0.00,
    },
    activityPassPricing: {
      enabled: true,
      price: 0,
      isFree: true,
      quantity: 1,
    },
    availableFrom: new Date('2024-09-15'),
    availableTo: new Date('2024-10-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 2,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440033',
    name: 'Athletic Trainer Fee',
    description: 'Access to athletic training and physical therapy services',
    categoryId: '6',
    basePrice: 50.00,
    reducedPrice: 25.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440034',
    name: 'Locker Rental',
    description: 'Annual locker rental with combination lock',
    categoryId: '6',
    basePrice: 15.00,
    reducedPrice: 7.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-08-01'),
    availableTo: new Date('2025-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440035',
    name: 'Digital Textbook Bundle',
    description: 'All-access digital textbook subscription for the year',
    categoryId: '3',
    basePrice: 175.00,
    reducedPrice: 87.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440036',
    name: 'Calculus Study Materials',
    description: 'Supplementary study guides and practice problem sets',
    categoryId: '3',
    course: 'AP Calculus',
    basePrice: 38.00,
    reducedPrice: 19.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440037',
    name: 'Physics Lab Equipment',
    description: 'Required lab equipment and safety materials for physics',
    categoryId: '3',
    course: 'AP Physics',
    basePrice: 68.00,
    reducedPrice: 34.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440038',
    name: 'Environmental Science Field Kit',
    description: 'Field testing equipment for environmental science course',
    categoryId: '3',
    course: 'Environmental Science',
    basePrice: 72.00,
    reducedPrice: 36.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440039',
    name: 'Computer Science Software License',
    description: 'Annual software license for computer science students',
    categoryId: '3',
    course: 'Computer Science',
    basePrice: 55.00,
    reducedPrice: 27.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440040',
    name: 'Welding Course Materials',
    description: 'Safety equipment and consumables for welding class',
    categoryId: '3',
    course: 'Welding Technology',
    basePrice: 135.00,
    reducedPrice: 67.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440041',
    name: 'Auto Shop Safety Equipment',
    description: 'Required safety gear and materials for automotive class',
    categoryId: '3',
    course: 'Automotive Technology',
    basePrice: 88.00,
    reducedPrice: 44.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440042',
    name: 'Journalism Portfolio Kit',
    description: 'Professional portfolio materials and printing credits',
    categoryId: '3',
    course: 'Journalism',
    basePrice: 45.00,
    reducedPrice: 22.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440043',
    name: 'Psychology Study Materials',
    description: 'Case studies and research materials for psychology course',
    categoryId: '3',
    course: 'AP Psychology',
    basePrice: 52.00,
    reducedPrice: 26.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440044',
    name: 'Economics Simulation Software',
    description: 'Virtual trading platform access for economics students',
    categoryId: '3',
    course: 'AP Economics',
    basePrice: 40.00,
    reducedPrice: 20.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440045',
    name: 'Anatomy & Physiology Models',
    description: 'Study models and dissection materials for anatomy class',
    categoryId: '3',
    course: 'Anatomy & Physiology',
    basePrice: 78.00,
    reducedPrice: 39.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440046',
    name: 'Ceramics Class Materials',
    description: 'Clay, glazes, and firing fees for ceramics students',
    categoryId: '3',
    course: 'Ceramics',
    basePrice: 92.00,
    reducedPrice: 46.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440047',
    name: 'Woodworking Safety Kit',
    description: 'Safety equipment and project materials for woodworking',
    categoryId: '3',
    course: 'Woodworking',
    basePrice: 105.00,
    reducedPrice: 52.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440048',
    name: 'Graphic Design Software',
    description: 'Adobe Creative Cloud subscription for design students',
    categoryId: '3',
    course: 'Graphic Design',
    basePrice: 120.00,
    reducedPrice: 60.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440049',
    name: 'Dance Workshop Series',
    description: 'Guest instructor workshops for advanced dance students',
    categoryId: '5',
    basePrice: 65.00,
    reducedPrice: 32.50,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 65.00,
      adult: 0.00,
      senior: 0.00,
    },
    availableFrom: new Date('2025-01-01'),
    availableTo: new Date('2025-03-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440050',
    name: 'STEM Competition Entry',
    description: 'Registration for regional STEM competition',
    categoryId: '4',
    basePrice: 55.00,
    reducedPrice: 27.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-11-01'),
    availableTo: new Date('2025-01-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440051',
    name: 'College Visit Trip',
    description: 'Transportation and materials for college campus visits',
    categoryId: '4',
    basePrice: 85.00,
    reducedPrice: 42.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-03-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440052',
    name: 'Choir Concert Attire',
    description: 'Formal concert attire for choir performances',
    categoryId: '6',
    basePrice: 75.00,
    reducedPrice: 37.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-10-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440053',
    name: 'SAT Prep Course',
    description: 'Comprehensive SAT preparation course with materials',
    categoryId: '6',
    basePrice: 250.00,
    reducedPrice: 125.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-01-01'),
    availableTo: new Date('2025-04-30'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440054',
    name: 'ACT Prep Materials',
    description: 'Study guides and practice tests for ACT preparation',
    categoryId: '6',
    basePrice: 95.00,
    reducedPrice: 47.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440055',
    name: 'Student ID Replacement',
    description: 'Replacement fee for lost or damaged student ID card',
    categoryId: '6',
    basePrice: 10.00,
    reducedPrice: 5.00,
    freePrice: 0.00,
    availableFrom: new Date('2024-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 5,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440056',
    name: 'Winter Formal Ticket',
    description: 'Entry to annual winter formal dance',
    categoryId: '5',
    basePrice: 35.00,
    reducedPrice: 17.50,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 35.00,
      adult: 0.00,
      senior: 0.00,
    },
    availableFrom: new Date('2024-11-01'),
    availableTo: new Date('2024-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: true,
    maxQuantity: 2,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440057',
    name: 'Graduation Cap and Gown',
    description: 'Official graduation regalia package',
    categoryId: '6',
    basePrice: 85.00,
    reducedPrice: 42.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-03-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440058',
    name: 'Senior Class Ring',
    description: 'Customized senior class ring',
    categoryId: '6',
    basePrice: 295.00,
    reducedPrice: 147.50,
    freePrice: 0.00,
    availableFrom: new Date('2025-09-01'),
    availableTo: new Date('2026-03-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
    allowsPartialPayment: true,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440059',
    name: 'Anime Club Membership',
    description: 'Annual membership for anime and manga club',
    categoryId: '6',
    basePrice: 25.00,
    reducedPrice: 12.50,
    freePrice: 0.00,
    availableFrom: new Date('2024-09-01'),
    availableTo: new Date('2025-05-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440002'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440060',
    name: 'Chess Club Tournament Fee',
    description: 'Entry fees for regional chess tournaments',
    categoryId: '6',
    basePrice: 30.00,
    reducedPrice: 15.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-08-01'),
    availableTo: new Date('2026-06-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: false,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440061-student',
    name: 'Varsity Basketball vs. Central High - Student/Child',
    description: 'Friday night varsity basketball game - Home game at 7:00 PM',
    categoryId: '5',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-28'),
    availableTo: new Date('2026-01-02'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 85,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440061-adult',
    name: 'Varsity Basketball vs. Central High - Adult',
    description: 'Friday night varsity basketball game - Home game at 7:00 PM',
    categoryId: '5',
    basePrice: 8.00,
    reducedPrice: 8.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-28'),
    availableTo: new Date('2026-01-02'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 90,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440061-senior',
    name: 'Varsity Basketball vs. Central High - Senior',
    description: 'Friday night varsity basketball game - Home game at 7:00 PM',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-28'),
    availableTo: new Date('2026-01-02'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 70,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440062-student',
    name: 'Varsity Football Championship - Student/Child',
    description: 'Regional championship football game - Saturday at 2:00 PM',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-29'),
    availableTo: new Date('2026-01-03'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 88,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440062-adult',
    name: 'Varsity Football Championship - Adult',
    description: 'Regional championship football game - Saturday at 2:00 PM',
    categoryId: '5',
    basePrice: 12.00,
    reducedPrice: 12.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-29'),
    availableTo: new Date('2026-01-03'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 95,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440062-senior',
    name: 'Varsity Football Championship - Senior',
    description: 'Regional championship football game - Saturday at 2:00 PM',
    categoryId: '5',
    basePrice: 9.00,
    reducedPrice: 9.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-29'),
    availableTo: new Date('2026-01-03'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 72,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440063-student',
    name: 'JV Basketball vs. Riverside - Student/Child',
    description: 'Junior varsity basketball game - Tuesday at 6:00 PM',
    categoryId: '5',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-30'),
    availableTo: new Date('2026-01-06'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 65,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440063-adult',
    name: 'JV Basketball vs. Riverside - Adult',
    description: 'Junior varsity basketball game - Tuesday at 6:00 PM',
    categoryId: '5',
    basePrice: 5.00,
    reducedPrice: 5.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-30'),
    availableTo: new Date('2026-01-06'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 70,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440063-senior',
    name: 'JV Basketball vs. Riverside - Senior',
    description: 'Junior varsity basketball game - Tuesday at 6:00 PM',
    categoryId: '5',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 0.00,
    availableFrom: new Date('2025-12-30'),
    availableTo: new Date('2026-01-06'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 55,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440064-student',
    name: 'Swimming District Finals - Student/Child',
    description: 'District championship swimming and diving competition - Saturday at 10:00 AM',
    categoryId: '5',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-02'),
    availableTo: new Date('2026-01-10'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 60,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440064-adult',
    name: 'Swimming District Finals - Adult',
    description: 'District championship swimming and diving competition - Saturday at 10:00 AM',
    categoryId: '5',
    basePrice: 7.00,
    reducedPrice: 7.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-02'),
    availableTo: new Date('2026-01-10'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 68,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440064-senior',
    name: 'Swimming District Finals - Senior',
    description: 'District championship swimming and diving competition - Saturday at 10:00 AM',
    categoryId: '5',
    basePrice: 5.50,
    reducedPrice: 5.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-02'),
    availableTo: new Date('2026-01-10'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 52,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440065-student',
    name: 'Basketball vs. Westfield - Student/Child',
    description: 'Conference basketball game - Thursday at 7:30 PM',
    categoryId: '5',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-06'),
    availableTo: new Date('2026-01-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 78,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440065-adult',
    name: 'Basketball vs. Westfield - Adult',
    description: 'Conference basketball game - Thursday at 7:30 PM',
    categoryId: '5',
    basePrice: 8.00,
    reducedPrice: 8.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-06'),
    availableTo: new Date('2026-01-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 85,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440065-senior',
    name: 'Basketball vs. Westfield - Senior',
    description: 'Conference basketball game - Thursday at 7:30 PM',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-06'),
    availableTo: new Date('2026-01-15'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 62,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440066-student',
    name: 'Girls Basketball Tournament - Student/Child',
    description: 'Weekend basketball tournament - All day Saturday and Sunday',
    categoryId: '5',
    basePrice: 5.00,
    reducedPrice: 5.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-12'),
    availableTo: new Date('2026-01-18'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 72,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440066-adult',
    name: 'Girls Basketball Tournament - Adult',
    description: 'Weekend basketball tournament - All day Saturday and Sunday',
    categoryId: '5',
    basePrice: 10.00,
    reducedPrice: 10.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-12'),
    availableTo: new Date('2026-01-18'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 80,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440066-senior',
    name: 'Girls Basketball Tournament - Senior',
    description: 'Weekend basketball tournament - All day Saturday and Sunday',
    categoryId: '5',
    basePrice: 7.50,
    reducedPrice: 7.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-01-12'),
    availableTo: new Date('2026-01-18'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 58,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440067-student',
    name: 'Baseball Opening Game - Student/Child',
    description: 'Season opener vs. Lincoln High - Home game at 4:00 PM',
    categoryId: '5',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-02-20'),
    availableTo: new Date('2026-03-05'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 62,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440067-adult',
    name: 'Baseball Opening Game - Adult',
    description: 'Season opener vs. Lincoln High - Home game at 4:00 PM',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-02-20'),
    availableTo: new Date('2026-03-05'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 70,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440067-senior',
    name: 'Baseball Opening Game - Senior',
    description: 'Season opener vs. Lincoln High - Home game at 4:00 PM',
    categoryId: '5',
    basePrice: 4.50,
    reducedPrice: 4.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-02-20'),
    availableTo: new Date('2026-03-05'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 50,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440068-student',
    name: 'Baseball vs. North High - Student/Child',
    description: 'Conference baseball game - Friday at 5:00 PM',
    categoryId: '5',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-03-10'),
    availableTo: new Date('2026-03-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 58,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440068-adult',
    name: 'Baseball vs. North High - Adult',
    description: 'Conference baseball game - Friday at 5:00 PM',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-03-10'),
    availableTo: new Date('2026-03-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 65,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440068-senior',
    name: 'Baseball vs. North High - Senior',
    description: 'Conference baseball game - Friday at 5:00 PM',
    categoryId: '5',
    basePrice: 4.50,
    reducedPrice: 4.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-03-10'),
    availableTo: new Date('2026-03-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 48,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440069-student',
    name: 'Swimming Invitational - Student/Child',
    description: 'Multi-school swimming invitational - All day Saturday',
    categoryId: '5',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-03-15'),
    availableTo: new Date('2026-03-28'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 55,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440069-adult',
    name: 'Swimming Invitational - Adult',
    description: 'Multi-school swimming invitational - All day Saturday',
    categoryId: '5',
    basePrice: 7.00,
    reducedPrice: 7.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-03-15'),
    availableTo: new Date('2026-03-28'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 62,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440069-senior',
    name: 'Swimming Invitational - Senior',
    description: 'Multi-school swimming invitational - All day Saturday',
    categoryId: '5',
    basePrice: 5.50,
    reducedPrice: 5.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-03-15'),
    availableTo: new Date('2026-03-28'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 45,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440070-student',
    name: 'Baseball Senior Night - Student/Child',
    description: 'Senior recognition night and home game - Wednesday at 6:00 PM',
    categoryId: '5',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-04-15'),
    availableTo: new Date('2026-04-29'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 68,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440070-adult',
    name: 'Baseball Senior Night - Adult',
    description: 'Senior recognition night and home game - Wednesday at 6:00 PM',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-04-15'),
    availableTo: new Date('2026-04-29'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 75,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440070-senior',
    name: 'Baseball Senior Night - Senior',
    description: 'Senior recognition night and home game - Wednesday at 6:00 PM',
    categoryId: '5',
    basePrice: 4.50,
    reducedPrice: 4.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-04-15'),
    availableTo: new Date('2026-04-29'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 55,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440071-student',
    name: 'Baseball Playoff Game - Student/Child',
    description: 'Regional playoff baseball game - Time TBD',
    categoryId: '5',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-05-01'),
    availableTo: new Date('2026-05-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 78,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440071-adult',
    name: 'Baseball Playoff Game - Adult',
    description: 'Regional playoff baseball game - Time TBD',
    categoryId: '5',
    basePrice: 8.00,
    reducedPrice: 8.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-05-01'),
    availableTo: new Date('2026-05-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 85,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440071-senior',
    name: 'Baseball Playoff Game - Senior',
    description: 'Regional playoff baseball game - Time TBD',
    categoryId: '5',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-05-01'),
    availableTo: new Date('2026-05-20'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 62,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440072-student',
    name: 'State Swimming Championships - Student/Child',
    description: 'State championship swimming meet - Friday and Saturday',
    categoryId: '5',
    basePrice: 5.00,
    reducedPrice: 5.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-05-10'),
    availableTo: new Date('2026-05-22'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 70,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440072-adult',
    name: 'State Swimming Championships - Adult',
    description: 'State championship swimming meet - Friday and Saturday',
    categoryId: '5',
    basePrice: 10.00,
    reducedPrice: 10.00,
    freePrice: 0.00,
    availableFrom: new Date('2026-05-10'),
    availableTo: new Date('2026-05-22'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 82,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440072-senior',
    name: 'State Swimming Championships - Senior',
    description: 'State championship swimming meet - Friday and Saturday',
    categoryId: '5',
    basePrice: 7.50,
    reducedPrice: 7.50,
    freePrice: 0.00,
    availableFrom: new Date('2026-05-10'),
    availableTo: new Date('2026-05-22'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 10,
    feeType: 'event_ticket',
    popularityScore: 58,
  },
  {
    id: '850e8400-e29b-41d4-a716-446655440073',
    name: 'Valentine\'s Dance Ticket',
    description: 'Semi-formal Valentine\'s Day dance in the gymnasium - Friday, February 14th from 7:00 PM to 10:00 PM. DJ, refreshments, and photo booth included.',
    categoryId: '5',
    basePrice: 25.00,
    reducedPrice: 12.50,
    freePrice: 0.00,
    eventPricing: {
      studentChild: 25.00,
      adult: 0.00,
      senior: 0.00,
    },
    activityPassPricing: {
      enabled: true,
      price: 10.00,
      isFree: false,
      quantity: 1,
    },
    availableFrom: new Date('2026-01-15'),
    availableTo: new Date('2026-02-14'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 2,
  },
  {
    id: 'concession-001',
    name: 'Hot Dog',
    description: 'Classic all-beef hot dog with bun',
    categoryId: '7',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 4.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 95,
  },
  {
    id: 'concession-002',
    name: 'Hamburger',
    description: 'Quarter-pound beef patty with lettuce, tomato, onion',
    categoryId: '7',
    basePrice: 6.00,
    reducedPrice: 6.00,
    freePrice: 6.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 88,
  },
  {
    id: 'concession-003',
    name: 'Cheeseburger',
    description: 'Quarter-pound beef patty with American cheese',
    categoryId: '7',
    basePrice: 7.00,
    reducedPrice: 7.00,
    freePrice: 7.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 82,
  },
  {
    id: 'concession-004',
    name: 'Nachos with Cheese',
    description: 'Crispy tortilla chips with warm cheese sauce',
    categoryId: '7',
    basePrice: 5.00,
    reducedPrice: 5.00,
    freePrice: 5.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 78,
  },
  {
    id: 'concession-005',
    name: 'Popcorn (Large)',
    description: 'Freshly popped buttered popcorn',
    categoryId: '7',
    basePrice: 4.50,
    reducedPrice: 4.50,
    freePrice: 4.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 92,
  },
  {
    id: 'concession-006',
    name: 'Popcorn (Small)',
    description: 'Freshly popped buttered popcorn',
    categoryId: '7',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 3.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 75,
  },
  {
    id: 'concession-007',
    name: 'Soft Pretzel',
    description: 'Warm salted soft pretzel with cheese dip',
    categoryId: '7',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 4.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 65,
  },
  {
    id: 'concession-008',
    name: 'Pizza Slice',
    description: 'Large cheese pizza slice',
    categoryId: '7',
    basePrice: 3.50,
    reducedPrice: 3.50,
    freePrice: 3.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 85,
  },
  {
    id: 'concession-009',
    name: 'Chicken Tenders',
    description: 'Crispy chicken tenders (3 piece) with sauce',
    categoryId: '7',
    basePrice: 6.50,
    reducedPrice: 6.50,
    freePrice: 6.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 72,
  },
  {
    id: 'concession-010',
    name: 'French Fries',
    description: 'Golden crispy french fries',
    categoryId: '7',
    basePrice: 3.50,
    reducedPrice: 3.50,
    freePrice: 3.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 80,
  },
  {
    id: 'concession-011',
    name: 'Soda (Large)',
    description: 'Choice of Coca-Cola, Sprite, or Dr Pepper',
    categoryId: '7',
    basePrice: 3.50,
    reducedPrice: 3.50,
    freePrice: 3.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 90,
  },
  {
    id: 'concession-012',
    name: 'Soda (Small)',
    description: 'Choice of Coca-Cola, Sprite, or Dr Pepper',
    categoryId: '7',
    basePrice: 2.50,
    reducedPrice: 2.50,
    freePrice: 2.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 70,
  },
  {
    id: 'concession-013',
    name: 'Bottled Water',
    description: '16.9 oz bottled water',
    categoryId: '7',
    basePrice: 2.00,
    reducedPrice: 2.00,
    freePrice: 2.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 88,
  },
  {
    id: 'concession-014',
    name: 'Gatorade',
    description: 'Sports drink - various flavors',
    categoryId: '7',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 3.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 68,
  },
  {
    id: 'concession-015',
    name: 'Hot Chocolate',
    description: 'Rich and creamy hot chocolate',
    categoryId: '7',
    basePrice: 2.50,
    reducedPrice: 2.50,
    freePrice: 2.50,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 55,
  },
  {
    id: 'concession-016',
    name: 'Coffee',
    description: 'Fresh brewed coffee',
    categoryId: '7',
    basePrice: 2.00,
    reducedPrice: 2.00,
    freePrice: 2.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 45,
  },
  {
    id: 'concession-017',
    name: 'Candy Bar',
    description: 'Assorted candy bars (Snickers, Twix, etc.)',
    categoryId: '7',
    basePrice: 2.00,
    reducedPrice: 2.00,
    freePrice: 2.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 60,
  },
  {
    id: 'concession-018',
    name: 'Chips',
    description: 'Bag of chips - various flavors',
    categoryId: '7',
    basePrice: 2.00,
    reducedPrice: 2.00,
    freePrice: 2.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 58,
  },
  {
    id: 'concession-019',
    name: 'Ice Cream Bar',
    description: 'Ice cream novelty bar',
    categoryId: '7',
    basePrice: 3.00,
    reducedPrice: 3.00,
    freePrice: 3.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 62,
  },
  {
    id: 'concession-020',
    name: 'Cotton Candy',
    description: 'Fresh spun cotton candy',
    categoryId: '7',
    basePrice: 4.00,
    reducedPrice: 4.00,
    freePrice: 4.00,
    availableFrom: new Date('2024-01-01'),
    availableTo: new Date('2030-12-31'),
    isActive: true,
    schoolId,
    schoolYearIds: ['1050e8400-e29b-41d4-a716-446655440004'],
    requiresQuantity: true,
    maxQuantity: 20,
    feeType: 'concession',
    popularityScore: 50,
  },
];
